import React from "react";
import "../styles/SignInImageView.css";
import AzaleaSignIn from "../assests/SignInImages/azaleaSignInfurnature.png";
import AzaleaLogo from "../assests/SignInImages/AzaleaLogo.png";

function SignInImageView() {
  return (
    <div className="image-view-container">
      <div className="image-view-container-back-image">
        <img
          src={AzaleaSignIn}
          className="image-view-container-back-image-furnature"
          alt="background-furniture"
        />
      </div>
      <div className="image-view-logo-container">
        <img
          src="https://dev-azalea-s3-bucket.s3.me-central-1.amazonaws.com/Lebanon/App/APPLICATION/AzaleaLogo3675797152286851248.png"
          className="image-view-logo-container-log"
          alt="sign-in-azalea-logo"
        />
      </div>
    </div>
  );
}

export default SignInImageView;
